import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {WidgetDistribucionRolesComponent} from "./widget-distribucion-roles.component";

@NgModule({
  declarations: [
    WidgetDistribucionRolesComponent
  ],
  exports: [
    WidgetDistribucionRolesComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ]
})
export class WidgetDistribucionRolesModule {
}
